'use client';

import { Analytics } from '@vercel/analytics/next';

type ProvidersProps = {
  children: React.ReactNode;
};

export function Providers({ children }: ProvidersProps) {
  return (
    <>
      {children}
      {process.env.NEXT_PUBLIC_APP_ENV === 'production' && <Analytics />}
    </>
  );
}
